import { forwardRef } from 'react';

import { IconProps } from './icons.types';

import { SvgStyled } from './icons.styles';

export const SpeedometerIcon = forwardRef<SVGSVGElement, IconProps>(function SpeedometerIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 9.43902C0 4.2285 4.03182 0 9 0C13.9682 0 18 4.2285 18 9.43902C18 12.006 17.0187 14.3477 15.4254 16.0471C15.1822 16.3064 14.7847 16.3099 14.5374 16.0549C14.2902 15.7999 14.2868 15.383 14.53 15.1236C15.9004 13.662 16.7442 11.6487 16.7442 9.43902C16.7442 4.95589 13.2746 1.31707 9 1.31707C4.72539 1.31707 1.25581 4.95589 1.25581 9.43902C1.25581 11.6488 2.09146 13.646 3.45575 15.1175C3.6975 15.3782 3.69194 15.7952 3.44331 16.0487C3.19469 16.3023 2.79716 16.2964 2.55541 16.0357C0.972724 14.3286 0 12.0058 0 9.43902ZM10.4651 7.68293C10.4651 6.5876 11.3183 5.70732 12.3488 5.70732C13.3821 5.70732 14.2326 6.59923 14.2326 7.68293C14.2326 8.77826 13.3794 9.65854 12.3488 9.65854H11.7209C11.0309 9.65854 10.4651 9.06516 10.4651 8.34146V7.68293ZM12.3488 7.02439C12.0064 7.02439 11.7209 7.3207 11.7209 7.68293V8.34146H12.3488C12.6913 8.34146 12.9767 8.04516 12.9767 7.68293C12.9767 7.32663 12.6886 7.02439 12.3488 7.02439ZM9 12.0644C7.78395 12.0644 6.79814 13.0983 6.79814 14.3737C6.79814 15.649 7.78394 16.6829 9 16.6829C10.2161 16.6829 11.2019 15.649 11.2019 14.3737C11.2019 13.0983 10.2161 12.0644 9 12.0644ZM5.54232 14.3737C5.54232 12.3709 7.09038 10.7473 9 10.7473C10.9096 10.7473 12.4577 12.3709 12.4577 14.3737C12.4577 16.3764 10.9096 18 9 18C7.09038 18 5.54232 16.3764 5.54232 14.3737Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
